import axios from "axios";
import { BASE_URL } from "../constants";
import { CONTENT_TYPE } from "../constants";

async function Post(path, postData, token, paramObj, contentType = CONTENT_TYPE.JSON) {
  let url = BASE_URL + path;

  const isFormData = typeof FormData !== "undefined" && postData instanceof FormData;

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(!isFormData && { "Content-Type": contentType }),
  };

  const config = {
    headers,
    ...(paramObj && { params: paramObj }),
  };

  try {
    const response = await axios.post(url, postData, config);
    return response;
  } catch (error) {
    // Network error
    if (error.message === "Network Error") {
      return {
        status: 500,
        data: { message: "Connection Failed, Server not responding" },
      };
    }
    
    // If it's an axios error with a response
    if (error.response) {
      if (error.response.status === 401) {
        const theme = localStorage.getItem("birchwood_theme");
        localStorage.clear();
        if (theme) localStorage.setItem("birchwood_theme", theme);
        window.location.href = "/signin?error_code=session_expired";
      }
      const body = error.response.data;
      const pre = typeof body === "string" ? body.match(/<pre>([^<]+)<\/pre>/i) : null;
      const message =
        pre?.[1]?.trim() ||
        (body && typeof body.message === "string" && !body.message.includes("<")
          ? body.message
          : "Request failed");
      const err = new Error(message);
      err.status = error.response.status;
      err.data = typeof body === "string" ? { message } : body;
      throw err;
    }
    
    console.error("Error response:", error.response.data);
    // Throw unknown error
    const err = new Error("Request failed");
    err.status = 500;
    err.data = error.response?.data;
    throw err;
  }
}

export { Post };
